import { ExpressPaymentMethodStatus } from '../../models/expressCheckout';
import { CheckoutState } from '../../state';
import {
    areExpressCheckoutConditionsLoaded,
    isApplePayAvailableAsExpressPaymentMethod,
} from '../expressCheckoutConditions';
import { getApplePayInstance } from './pureSelectors';

export const getApplePayExpressPaymentMethodStatus = (state: CheckoutState) => {
    if (!areExpressCheckoutConditionsLoaded(state)) {
        return ExpressPaymentMethodStatus.availabilityNotEvaluatedYet;
    }

    if (!isApplePayAvailableAsExpressPaymentMethod(state)) {
        return ExpressPaymentMethodStatus.unavailable;
    }

    return getApplePayInstance(state)
        ? ExpressPaymentMethodStatus.fullyLoaded
        : ExpressPaymentMethodStatus.loadingScripts;
};
